var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"steps"},_vm._l((_vm.steps),function(step,index){return _c('div',{staticClass:"step",class:[
        `step-${step.step}`,
        index === 0 ? 'first' : '',
        index === _vm.steps.length - 1 ? 'last' : '',
        step.active ? 'active' : 'inactive',
        step.completed ? 'completed' : '',
        ]},[_c('span',{staticClass:"step-details"},[_c('span',{staticClass:"number"},[_vm._v("\n                    "+_vm._s(step.completed ? '✓' : step.step)+"\n                ")]),_vm._v(" "),_c('a',{staticClass:"name",attrs:{"href":step.completed ? step.href : '#'}},[_c('span',[_vm._v("\n                        "+_vm._s(step.name)+"\n                    ")])])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }